import React from "react"
import { WebSiteHeightProvider } from "./src/context"
import { AdminAuthProvider } from "./src/components/Admin/AdminAuthProvider"
import { installTouchInteractions } from "./src/assets/js/touch-interactions"
import { ConsentProvider } from "./src/privacy/ConsentProvider"
import { beforeRouteUpdate, trackRoute } from "./src/privacy/tracking"

export const onClientEntry = () => {
  installTouchInteractions()
}

export const wrapRootElement = ({ element }) => (
  <WebSiteHeightProvider>
    <ConsentProvider>{element}</ConsentProvider>
  </WebSiteHeightProvider>
)

export const onPreRouteUpdate = beforeRouteUpdate
export const onRouteUpdate = trackRoute

export const wrapPageElement = ({ element, props }) => {
  const pathname = props.location.pathname
  const isAdminRoute = pathname === "/admin" || pathname.startsWith("/admin/")

  return isAdminRoute ? (
    <AdminAuthProvider>{element}</AdminAuthProvider>
  ) : (
    element
  )
}
